import { useQuery } from "@tanstack/react-query";
import api from "api/landlord/applications";
import { VerificationNames } from "shared/types";
import { VerificationReport } from "types/landlord/reports";
import { WarningsReportPayload } from "api/landlord/warnings-report/types";
import { getVerificationQueryKeys } from "views/applications-id-report/utils/getVerificationQueryKeys";
import { countTriggeredRules } from "../utils";
import { Cell } from "./Cell";

interface WarningsReportCellProps {
  applicationId: number;
  applicantId: number;
  verificationId: number;
}

export const WarningsReportCell = ({
  applicationId,
  applicantId,
  verificationId
}: WarningsReportCellProps) => {
  const { data } = useQuery<VerificationReport<WarningsReportPayload>>({
    queryKey: getVerificationQueryKeys({
      reportName: VerificationNames.WarningsReport,
      applicationId,
      applicantId,
      verificationId
    }),
    queryFn: () =>
      api
        .getApplicantVerification(applicationId, applicantId, verificationId)
        .then((d) => d.verification),
    enabled: Number.isInteger(verificationId) && verificationId > 0
  });

  return (
    <Cell isDataCell className="relative">
      {data ? countTriggeredRules(data.report) : "—"}
    </Cell>
  );
};
